import { Box, CardBodyProps, CardRootProps, Flex, Card as NativeCard, Spacer } from "@chakra-ui/react"
import React, { ReactNode } from "react";
import { SPACING } from "../generic/config";
import Divider from "./Divider";
import Text from "./Text";

type CardProps = {
    children?: ReactNode,
    title?: string,
    titleAddon?: ReactNode,
    description?: string | ReactNode,
    border?: CardRootProps["border"],
    rightAddon?: ReactNode,
} & CardBodyProps

const Card = ({ children, title, titleAddon, description, border, rightAddon, ...rest }: CardProps) => {
    return (
        <NativeCard.Root maxW={`calc(100vw-${SPACING * 2}px)`} h={rest.height ?? rest.h ?? "100%"} border={border} borderRadius="md">
            <NativeCard.Body p={SPACING} {...rest}>
                <Flex>
                    <Box>
                        <Flex alignItems="center" gap={SPACING}>
                            <Text variant="title">{title}</Text>
                            {titleAddon}
                        </Flex>
                        {React.isValidElement(description) ? description : <Text fontSize="small">{description}</Text>}
                    </Box>
                    {rightAddon && (
                        <>
                            <Spacer />
                            {rightAddon}
                        </>
                    )}
                </Flex>
                {title || description ? <Divider /> : null}
                {children}
            </NativeCard.Body>
        </NativeCard.Root>
    )
}

export default Card;